var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/informationrequest/viewmodels/PartnerInformation',["require", "exports", "common/viewmodelbase", "plugins/dialog"], function (require, exports, common, dialog) {
    "use strict";
    var PartnerInformationViewModel = (function (_super) {
        __extends(PartnerInformationViewModel, _super);
        function PartnerInformationViewModel() {
            _super.call(this);
        }
        PartnerInformationViewModel.prototype.onActivated = function (context) {
            this.dontShow = false;
        };
        // #endregion ctor
        PartnerInformationViewModel.prototype.closeDialog = function () {
            dialog.close(this);
        };
        return PartnerInformationViewModel;
    }(common.ListViewModelBase));
});

